import React from 'react'

import { Grid, TextField, Button, Paper, Box, Typography, CircularProgress } from '@material-ui/core'
import { useMutation } from '@apollo/react-hooks'
import { SEND_EMAIL } from './queries'
import { useStyles } from './styles'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import FooterLogos from  '../../components/FooterLogos'

function ForgotMyPasswordPage() {
  const classes = useStyles()
  const [email, setEmail] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  const [sendEmail, { loading, error }] = useMutation(SEND_EMAIL, {
    onCompleted: () => toast.success(
      'O e-mail com as instruções para a troca da senha foi enviado!'
    )
  })

  React.useEffect(() => {
    if(error) {
      toast.error(error.message.split(':')[1])
    }
  }, [error])

  const handleSendEmail = () => {
    sendEmail({
      variables: {
        email
      }
    })
  }

  React.useEffect(() => {
    if (email) {
      let errorMessage = ''
      if (!email.match(/\w+@\w+\.\w+/)) errorMessage = 'O e-mail digitado está inválido'
      if (!email.includes('.'))         errorMessage = 'O e-mail precisa conter um .'
      if (!email.includes('@'))         errorMessage = 'O e-mail precisa conter um @'

      setEmailError(errorMessage)
    }
  }, [email])

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: '100%' }}
    >
      <Grid item xs={ 10 } md={ 5 }>
        <Paper elevation={ 1 } className={ classes.wrapper }>
          <Grid
            container
            justify="center"
            alignItems="center"
          >

            <Grid item xs={ 10 } className={ classes.title }>
              <Box mt={ 2 }>
                <Typography variant="h2" noWrap><b>ISE</b>B3</Typography>
              </Box>
              <Box mt={ 1 }>
                <Typography variant="p" className={ classes.subtitle }>
                  Preencha o seu e-mail e enviaremos para você um link para
                  atualizar a sua senha.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={ 10 } className={ classes.field }>
              <TextField
                autoFocus
                fullWidth
                error={ !!emailError }
                helperText={ emailError }
                placeholder="E-mail"
                value={ email }
                onChange={ event => setEmail(event.target.value) }
              />
            </Grid>
            <Grid
              item
              xs={ 6 }
              className={ classes.submit }
            >
              <Button
                fullWidth
                onClick={ handleSendEmail }
                disabled={
                  !email || emailError
                }
              >
                {
                  loading
                    ? <CircularProgress size={ 25 } />
                    : 'Enviar'
                }
              </Button>
            </Grid>

            <Grid item xs={ 10 } className={ classes.loginLinkWrapper }>
              <Link to="/login" className={ classes.loginLink }>
                Ou clique aqui para fazer o login
              </Link>
            </Grid>
          </Grid>

          {/* <FooterLogos /> */}
        </Paper>
      </Grid>
    </Grid>
  )
}

export default ForgotMyPasswordPage
